import api from './api';
import { Taxs } from '@/types/tax.types';

export const handleCreateTax = async (params: any) => api.post<any>('Taxs/NewTax', { ...params });

export const handleGetTaxs = async () => api.get<Taxs.Response>(`Taxs/ListTaxs`, {});
